/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface CioSaveContinueModalArgs {
  saveDisabled: boolean;
  saveFailed: boolean;
  prompt?: string;
  canDiscardChanges?: boolean;
  canSaveChanges?: boolean;
  status?: string;
  onClose: () => unknown;
  onDiscard: () => unknown;
  onSave: () => unknown;
  showSaveTooltip?: boolean;
  saveTooltipContent?: string;
  continuationPromptOnSaveDisabled?: string;
}

export default class CioSaveContinueModal extends Component<CioSaveContinueModalArgs> {
  get canDiscardChanges() {
    return this.args.canDiscardChanges ?? true;
  }

  get canSaveChanges() {
    return this.args.canSaveChanges ?? true;
  }
}
